/**
 * Desktop PDP: caps the two-column media grid at 6 images (3 rows) with a
 * "Show more photos" button to reveal the rest, instead of rendering every
 * image up front. Most products here carry 12-20 images — an uncapped
 * grid made the media column (and so the whole page, since the info
 * column can't be shorter than it) run several times longer than the
 * actual product content (description, reviews) that follows it.
 *
 * Scoped to `.product-desktop-media` (the real desktop product gallery)
 * specifically, not `product-media-grid.liquid` in general, since that
 * shared snippet also renders quick-view's media — deliberately left
 * uncapped there.
 */
(function () {
  if (window.__ncPdpMediaGridLimit) return;
  window.__ncPdpMediaGridLimit = true;

  var VISIBLE_COUNT = 6;

  function isDesktopViewport() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function buildButton(hiddenCount) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn--outline product-media-grid__show-more';
    button.textContent = 'Show ' + hiddenCount + ' more photo' + (hiddenCount === 1 ? '' : 's');
    return button;
  }

  function setUp(grid) {
    var items = grid.querySelectorAll(':scope > .product-media-grid__item');
    if (items.length <= VISIBLE_COUNT) return;

    grid.classList.add('is-capped');
    var button = buildButton(items.length - VISIBLE_COUNT);
    items[VISIBLE_COUNT - 1].insertAdjacentElement('afterend', button);

    button.addEventListener('click', function () {
      grid.classList.remove('is-capped');
      button.remove();
    });
  }

  function init() {
    if (!isDesktopViewport()) return;
    document.querySelectorAll('.product-desktop-media .product-media-grid').forEach(setUp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
